<div class="modal-main-wrapper remote-camera-session-wrapper">
    <div class="close-container">
        <div class="img-container" (click)="cancel()">
            <img src="../../../assets/icons/Close.svg" tabindex="1" >
        </div>
    </div>
    <div class="content-wrapper">
        <span class="header-text">{{"RequestRemoteCameraView" | transloco}}</span>
        <div class="device-detail-wrapper">
            <img class="device-icon" src="../../../assets/icons/icon-peloris.svg" alt="peloris">
            <div class="description-wrapper">
                <label>{{data.deviceId}}</label>
                <span class="device-description">{{data.customer}} <span *ngIf="data.lab">({{data.lab}})</span></span>
            </div>
        </div>
        <label>{{"Recipient" | transloco}} *</label>
        <div class="email-wrapper">
        <div clickOutside class="email-select-wrapper" (clickOutside)="closeEmailSelect()">
            <div class="email-select" (click)="toggleEmailItemList()">
                <input type="email" email="true" class="input-controls email-text-control" [ngClass]="{'touched': isEmailControlTouched}"  (blur)="blurEvent()" [(ngModel)]="resultModel.email"
                    #emailId="ngModel" required />
            </div>
            <div *ngIf="showEmailItemList" class="email-select-item-list">
                <ul tabindex="-1" class="email-select-item" (click)="setEmail(item)"
                    *ngFor="let item of data.mailList">
                    {{item}}</ul>
            </div>
        </div>
            <span *ngIf="emailId.errors && (emailId.dirty || emailId.touched) && isEmailControlTouched" class="validation">{{"InvalidEmail" |
                transloco}}</span>
        </div>
       
        <label>{{"WorkOrder-CaseNumber" | transloco}}</label>
        <input type="text" class="input-controls"  [(ngModel)]="resultModel.workOrder" maxlength="255"/>
        <label> {{"Remarks" | transloco}}</label>
        <textarea class="input-controls remarks-input"  [(ngModel)]="resultModel.remarks" maxlength="255"></textarea>
        <div class="info-message-wrapper">
            <div class="colored-section"></div>
            <div class="content-section">
                <span>{{"CameraSessionInfo" | transloco}}</span>
                <img class="icon" src="../../../assets/icons/icon-information.svg" alt="info" />
            </div>
        </div>
     
    </div>
    <footer>
        <div class="button-wrapper">
            <button class="action-btn white-text start-button" (click)="initiateCameraSession()" [disabled]="emailId.errors">{{"StartSession" |
                transloco}}</button>
            <button class="action-btn white-text" (click)="cancel()">{{"Cancel" | transloco}}</button>
        </div>
    </footer>
</div>